module.exports = __webpack_public_path__ + "static/media/santamarta.d314b367.webp";